import styleConstants from './variables.module.scss';
import { OrderSide } from 'communication/types/order/OrderSide';

export const getColourForSide = (side?: OrderSide) => {
    switch (side) {
        case 'S':
            return styleConstants.sellColour;
        case 'SS':
            return styleConstants.shortColour;
        case 'B':
        default:
            return styleConstants.buyColour;
    }
};

export const getSideClass = (side: OrderSide) => {
    switch (side) {
        case 'B':
            return 'buy';
        case 'S':
            return 'sell';
        case 'SS':
            return 'short';
        default:
            return '';
    }
};
